import model from '@/services/api/device-model';

export default {
  namespaced: true,
  state: {
    models: [],
  },
  getters: {
    models: state => state.models,
  },
  mutations: {
    setModels: (state, payload) => {
      state.models = payload.data;
    },
  },
  actions: {
    getModels (state, options = {}) {
      return new Promise((resolve, reject) => {
        model.getModels(options)
          .then(({ data }) => {
            state.commit('setModels', data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
  },
};
